export default __webpack_public_path__ + "edead1cfdc446ac1b07aea9ce99ff9c9.png";